import { createSelector } from 'reselect';

const selectWallets = (state) => state.wallets.items;

export const selectPortfolioWallets = createSelector(
  (_, id) => id,
  selectWallets,
  (portfolioId, wallets) => wallets[portfolioId]
);

export const selectDefaultPortfolioWallet = createSelector(
  (_, id) => id,
  (s, portfolioId) => selectPortfolioWallets(s, portfolioId),
  (_, wallets) => wallets?.find((w) => w.isDefault)
);
